import axios from "axios";

export const getOutboundTemplates = () => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/OutboundTemplate/getTemplates")
    .then((res) => res.data);
};

export const getOutboundFields = (templateId) => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/OutboundTemplate/getFields/" + templateId)
    .then((res) => res.data);
};

export const getAllOutboundFields = () => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/OutboundTemplate/getAllFields/")
    .then((res) => res.data);
};

export const addOutboundTemplate = (newTemplate) => {
  return axios
    .post(import.meta.env.VITE_BACKEND_API + "/api/OutboundTemplate/addTemplate/", newTemplate)
    .then((res) => res.data);
};

export const editOutboundTemplate = (editedTemplate) => {
  return axios
    .put(import.meta.env.VITE_BACKEND_API + "/api/OutboundTemplate/editTemplate/", editedTemplate)
    .then((res) => res.data);
};

export const deleteOutboundTemplate = (templateId) => {
  return axios
    .delete(import.meta.env.VITE_BACKEND_API + "/api/OutboundTemplate/deleteTemplate/" + templateId)
    .then((res) => res.data);
};